// 宠物信息 localStorage 管理工具
const PET_INFO_KEY = 'wukong_pet_info';
const PET_LAST_FEED_AT_KEY = 'pet_last_feed_at';
const PET_IS_HUNGRY_KEY = 'pet_is_hungry';

/**
 * 获取存储的宠物阶段
 * @returns {Object|null} 只包含 Phase 的简单对象，如果不存在则返回 null
 */
export const getPetInfoFromStorage = () => {
  try {
    const stored = localStorage.getItem(PET_INFO_KEY);
    if (!stored) return null;
    
    const phase = JSON.parse(stored);
    // 返回符合原有结构的对象，只包含 Phase
    return {
      garden_info: {
        PetInfo: {
          Phase: phase
        }
      }
    };
  } catch (error) {
    console.error('读取宠物信息失败:', error);
    return null;
  }
};

/**
 * 保存宠物阶段到 localStorage
 * @param {Object} petInfo - 宠物信息对象（getGardenInfo 返回的 data）
 */
export const savePetInfoToStorage = (petInfo) => {
  try {
    if (!petInfo?.garden_info?.PetInfo?.Phase) return;
    
    // 只存储 Phase 字段
    const phase = petInfo.garden_info.PetInfo.Phase;
    localStorage.setItem(PET_INFO_KEY, JSON.stringify(phase));
  } catch (error) {
    console.error('保存宠物信息失败:', error);
  }
};

/**
 * 挨饿逻辑：上次投喂时间戳与冷却期
 * COOLDOWN_MS 可配置，当前 5 秒，后续可改为 6 小时：6 * 60 * 60 * 1000
 */
export const HUNGRY_COOLDOWN_MS = 5 * 60 * 60 * 1000; // 5 秒，可改为 6 * 60 * 60 * 1000（6 小时）

export const getLastFeedAt = () => {
  try {
    const v = localStorage.getItem(PET_LAST_FEED_AT_KEY);
    if (!v) return null;
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
};

export const setLastFeedAt = () => {
  try {
    localStorage.setItem(PET_LAST_FEED_AT_KEY, String(Date.now()));
  } catch (e) {
    console.error('保存投喂时间失败:', e);
  }
};

/** 挨饿状态持久化：切出再进入仍保持挨饿，直到成功投喂 */
export const getIsHungryPersisted = () => {
  try {
    return localStorage.getItem(PET_IS_HUNGRY_KEY) === '1';
  } catch {
    return false;
  }
};

export const setIsHungryPersisted = (hungry) => {
  try {
    if (hungry) {
      localStorage.setItem(PET_IS_HUNGRY_KEY, '1');
    } else {
      localStorage.removeItem(PET_IS_HUNGRY_KEY);
    }
  } catch (e) {
    console.error('保存挨饿状态失败:', e);
  }
};

/** 是否在投喂冷却期内（冷却期内不再触发挨饿） */
export const isInFeedCooldown = () => {
  const at = getLastFeedAt();
  if (!at) return false;
  return Date.now() - at < HUNGRY_COOLDOWN_MS;
};

/**
 * 清除存储的宠物信息
 */
export const clearPetInfoFromStorage = () => {
  try {
    localStorage.removeItem(PET_INFO_KEY);
  } catch (error) {
    console.error('清除宠物信息失败:', error);
  }
};
